module.exports = __webpack_public_path__ + "static/media/comments.a6917b81.svg";